var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 5.33337H40.5333C45.0138 5.33337 47.254 5.33337 48.9653 6.20532C50.4706 6.97231 51.6944 8.19615 52.4614 9.70145C53.3333 11.4127 53.3333 13.653 53.3333 18.1334V45.8667C53.3333 50.3471 53.3333 52.5873 52.4614 54.2986C51.6944 55.8039 50.4706 57.0278 48.9653 57.7948C47.254 58.6667 45.0138 58.6667 40.5333 58.6667H23.4667C18.9862 58.6667 16.746 58.6667 15.0347 57.7948C13.5294 57.0278 12.3056 55.8039 11.5386 54.2986C10.6667 52.5873 10.6667 50.3471 10.6667 45.8667V44M42.6667 34.6667H30.6667M42.6667 24H33.3333M42.6667 45.3334H21.3333M16 26.6667V12C16 9.7909 17.7909 8.00004 20 8.00004C22.2091 8.00004 24 9.7909 24 12V26.6667C24 31.085 20.4183 34.6667 16 34.6667C11.5817 34.6667 8 31.085 8 26.6667V16",
    stroke: "#414651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/file-upload.8f9c7f9aef6ca985340c1dc2e50e6a08.svg";
export { ForwardRef as ReactComponent };